import React, { useCallback } from "react";
import { useAsync } from "react-async";
import { oneLineTrim } from "common-tags";

import useThemeService from "../../services/theme-service/ThemeService";
import useConfiguration from "../../services/configuration/ConfigurationService";
import Button from "../button/Button";

export function ChangePassword() {
  const { themeClass } = useThemeService();
  const { get } = useConfiguration();
  const { data: configurationContent, isPending } = useAsync({ promiseFn: get });

  const composeChangePasswordUrl = useCallback(() => {
    return oneLineTrim`${configurationContent.authority}/oauth2/v2.0/authorize?
                p=${configurationContent.change_password_policy}
                &client_id=${configurationContent.clientId}
                &nonce=defaultNonce
                &redirect_uri=${configurationContent.redirect_uri}/my-account
                &scope=openid
                &response_type=id_token
                &prompt=login`;
  }, [configurationContent]);

  const redirect = useCallback(() => {
    window.location.href = composeChangePasswordUrl();
  }, [composeChangePasswordUrl]);

  return !isPending ? (
    <Button
      id="change-password"
      onClick={redirect}
      textKey={"general.change-password"}
      className={themeClass(["btn-small"])}
    />
  ) : null;
}
